import { h as i } from "vue";
const a = (s, r) => {
  const c = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill-rule="evenodd" d="M4.8 19.2c-1.795 0-3.2-2.115-3.2-4.818 0-2.702 1.405-4.817 3.2-4.817 1.795 0 3.2 2.115 3.2 4.817C8 17.085 6.595 19.2 4.8 19.2zm0-8.035c-.755 0-1.6 1.376-1.6 3.217 0 1.842.845 3.218 1.6 3.218.755 0 1.6-1.376 1.6-3.218 0-1.841-.845-3.217-1.6-3.217zm6.397 1.635C9.405 12.8 8 10.691 8 8s1.405-4.8 3.197-4.8 3.197 2.109 3.197 4.8-1.405 4.8-3.197 4.8zm0-8C10.443 4.8 9.6 6.168 9.6 8s.843 3.2 1.597 3.2c.753 0 1.597-1.368 1.597-3.2s-.844-3.2-1.597-3.2zm8.003 8c-1.795 0-3.2-2.109-3.2-4.8s1.405-4.8 3.2-4.8c1.795 0 3.2 2.109 3.2 4.8s-1.405 4.8-3.2 4.8zm0-8c-.755 0-1.6 1.368-1.6 3.2s.845 3.2 1.6 3.2c.755 0 1.6-1.368 1.6-3.2s-.845-3.2-1.6-3.2zm6.4 14.4c-1.795 0-3.2-2.115-3.2-4.818 0-2.702 1.405-4.817 3.2-4.817 1.795 0 3.2 2.115 3.2 4.817 0 2.703-1.405 4.818-3.2 4.818zm0-8.035c-.755 0-1.6 1.376-1.6 3.217 0 1.842.845 3.218 1.6 3.218.755 0 1.6-1.376 1.6-3.218 0-1.841-.845-3.217-1.6-3.217zM20.8 28.8c-1.389 0-2.328-.47-3.155-.885-.768-.384-1.43-.715-2.445-.715-1.01 0-1.672.331-2.44.715-.83.415-1.771.885-3.16.885-.89 0-1.726-.485-2.3-1.33-1.002-1.481-1.018-3.73-.044-6.168 1.755-4.387 4.65-6.902 7.942-6.902 3.293 0 6.19 2.515 7.943 6.902.974 2.439.958 4.687-.045 6.168-.571.845-1.41 1.33-2.3 1.33h.004zm-5.6-3.2c1.39 0 2.331.47 3.16.885.766.384 1.429.715 2.44.715.349 0 .704-.229.974-.626.692-1.019.647-2.768-.116-4.676C20.158 18.15 17.805 16 15.2 16s-4.958 2.149-6.458 5.898c-.763 1.908-.806 3.657-.116 4.676.268.399.624.626.974.626 1.011 0 1.675-.331 2.445-.717.829-.414 1.77-.885 3.155-.885v.002z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (s.title) {
    const e = document.createElementNS(c, "title");
    e.textContent = s.title, t.appendChild(e);
  }
  const m = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, n) => ({
    ...e,
    [n.name]: n.value
  }));
  return i(
    "svg",
    {
      ...m,
      ...r.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  a as default
};
//# sourceMappingURL=PawIcon.DIYsPJ4E.js.map
